import { trackEvent } from 'dibs-tracking';

type TrackDesignFeaturePayload = {
    action: string;
    label: 'profile' | 'project' | 'photo' | 'directory' | 'photos' | 'browse';
};

export const trackDesignFeature = ({ action, label }: TrackDesignFeaturePayload): void => {
    trackEvent({
        action,
        label,
        category: 'design features',
    });
};

type TrackViewProfileClickPayload = {
    action: 'photo' | 'trade directory';
};

export const trackViewProfileClick = ({ action }: TrackViewProfileClickPayload): void => {
    trackEvent({
        action,
        category: 'design features',
        label: 'view profile clicked',
    });
};

type TrackContactDesignerPayload = {
    label: 'profile' | 'directory';
};

export const trackContactDesignerClick = ({ label }: TrackContactDesignerPayload): void => {
    trackDesignFeature({
        action: 'contact designer clicked',
        label,
    });
};

export const trackContactDesignerSubmit = ({ label }: TrackContactDesignerPayload): void => {
    trackDesignFeature({
        action: 'contact designer submitted',
        label,
    });
};

type TrackShareProfilePayload = {
    label: 'profile' | 'project' | 'photo';
    shareType: 'email' | 'pinterest' | 'facebook' | 'twitter' | 'copy link';
};

export const trackShareProfile = ({ label, shareType }: TrackShareProfilePayload): void => {
    trackDesignFeature({
        action: `share profile - ${shareType}`,
        label,
    });
};

type TrackLoginSavePhotoFeaturePayload = {
    action: 'login complete' | 'login entry';
};

export const trackLoginSavePhotoFeature = ({ action }: TrackLoginSavePhotoFeaturePayload): void => {
    trackEvent({
        action,
        label: 'photo save',
        category: 'login',
    });
};

type TrackPhotoActionPayload = {
    label: TrackDesignFeaturePayload['label'];
};

export const trackSavePhoto = ({ label }: TrackPhotoActionPayload): void => {
    trackDesignFeature({
        action: 'photo save',
        label,
    });
};

export const trackPhotoClick = ({ label }: TrackPhotoActionPayload): void => {
    trackDesignFeature({
        action: 'photo click',
        label,
    });
};

export const trackRelatedSearchClick = ({ label }: TrackPhotoActionPayload): void => {
    trackDesignFeature({
        action: 'related search click',
        label,
    });
};
